import React from 'react';
import notfoundimage from './pagenotfound.jpg';
import { Grid } from '@mui/joy';
function Pagenotfound() {
  return (
    <>
      <Grid
      container
      justifyContent="center"
      alignItems='center'
      sx={{height : "100vh" , width : '100vw'}}      
      >
        <img src={notfoundimage} alt="Not Found" style={{height : "100%" , width : "100%" , objectFit : 'cover'}} />
      </Grid>
    </>
  );
}
export default Pagenotfound;
